module.exports = __webpack_public_path__ + "media/pause-button.a0a880eb.svg";